import React from 'react'

import AdventureCabSection from '../AdventureCabSection/AdventureCabSection'
import BookCabSection from '../BookCabSection/BookCabSection'

import RentBike from '../RentBike/RentBike'
import ChooseUsPage from '../ChooseUsPage/ChooseUsPage'
import OfferPage from '../OfferPage/OfferPage'
import FooterSection from '../FooterSection/FooterSection'
import HeroCab from '../HeroCab/HeroCab'
import CarRentalSection from '../CarRentalSection/CarRentalSection'
import GallerySection from '../GallerySection/GallerySection'

const Home = () => {
  return (
      <div>
         <HeroCab/>
          <AdventureCabSection />
          <BookCabSection />
          <CarRentalSection/>
          <RentBike />
          <ChooseUsPage />
      <OfferPage />
      <GallerySection/>
          <FooterSection/>
      </div>
  )
}

export default Home